import { render, staticRenderFns } from "./AllocationChartLegend.vue?vue&type=template&id=061eebbc&scoped=true"
import script from "./AllocationChartLegend.vue?vue&type=script&lang=ts&setup=true"
export * from "./AllocationChartLegend.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AllocationChartLegend.vue?vue&type=style&index=0&id=061eebbc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061eebbc",
  null
  
)

export default component.exports